const createResultOfPay = (state, action) => {
  if (state === undefined) {
    return false;
  }
  switch (action.type) {
    case 'CREATE_RESULT_OF_PAY':
      return action.payload;
    // A tab switch leaves the result screen: the stored submission reply
    // belongs to the previous tab's transaction.
    case 'RESET_TAB_STATE':
      return false;
    default:
      return state.resultOfPay;
  }
};

export { createResultOfPay };
